<template lang="html">
  <transition name="top-slide">
    <div class="update-prompt">
      <div class="">
        <h3>{{ $t('update_available') }}</h3>
        <p>{{ $t('update_prompt')}}</p>
      </div>
      <button class="btn" @click='reload'>
        <span class="glyphicon glyphicon-refresh"></span>
        {{ $t('update') }}
      </button>
    </div>
  </transition>
</template>

<script>
// fixed-position banner that is shown to notify the user
// that a new version of the media platform is available
export default {
  methods: {
    reload () {
      window.location = '/'
    }
  }
}
</script>
